import { useWidgetContext } from 'widgets/WidgetContext.tsx';
import { useMemo } from 'react';
import { useWidgetPortfolioSelectionStatus } from 'widgets/hooks.ts';
import styleConstants from 'styles/variables.module.scss';
import { useOrderVolumeProfileConfigSlice } from 'widgets/orderVolumeProfile/store/configuration/configSlice.ts';

const padding = 2 * parseInt(styleConstants.spaceAround);
const borderWidth = 2 * parseInt(styleConstants.layoutBorderWidth);

export const useOrderVolumeProfileDimensions = () => {
    const { height, width } = useWidgetContext();
    const { config } = useOrderVolumeProfileConfigSlice();
    const { hasValidSelection } = useWidgetPortfolioSelectionStatus();

    return useMemo(() => {
        const hideToolbar = !!config?.hideToolbar || !hasValidSelection;
        const toolbarHeight = hideToolbar ? 0 : 16;

        const toolbarConsumedHeight = hideToolbar ? 0 : toolbarHeight;
        const bodyHeight = hideToolbar
            ? height - borderWidth - padding
            : height - toolbarConsumedHeight - borderWidth - padding;

        return {
            bodyHeight,
            width,
            height,
        };
    }, [hasValidSelection, width, height, config]);
};
